const getUrl = path => {
  const protocol =
    `${process.env.DEFAULT_SECURE}` === 'true' ? 'https://' : 'http://';
  const localMs = process.env.LOCAL_MS;
  const base = `${protocol}${process.env.API_BASE_URL_MULTI}`;
  const url = `${base}${path}`;
  if (!localMs || !url.includes(base + localMs)) return url;
  return `http://localhost:3000/${path}`;
};

const whiteList = ['contentful/footer'];

export { getUrl, whiteList };
